import React from 'react';
import ReactDOM from 'react-dom';
import './styles/imports.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {API_URL} from "./components/data/constants";
import axios from "axios";

axios.interceptors.response.use(
    (response) => {
        return response
    },
    async function (error) {
        const originalRequest = error.config
        let refreshToken = localStorage.getItem('refreshToken')
        let accessToken = localStorage.getItem('accessToken')
        
        if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest && refreshToken && accessToken) {
            originalRequest._retry = true
            
            await axios
                .post(API_URL + "/Auth/RefreshToken", {
                    accessToken: localStorage.getItem("token"),
                    refreshToken: refreshToken,
                })
                .then((res) => {
                    if (res && res.status === 200 && res.data.accessToken) {
                        localStorage.setItem("token", res.data.accessToken.token);
                        localStorage.setItem("accessToken", `Bearer ${res.data.accessToken.token}`);
                        localStorage.setItem("refreshToken", res.data.refreshToken);
            
                        window.location.reload(false);
                        originalRequest.headers['Authorization'] = `Bearer ${res.data.accessToken.token}`;
                        return axios(originalRequest);
                    }

                    localStorage.removeItem('accessToken')
                    window.location.reload(false);
                    return Promise.reject(error);
                });
        }
    },
)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
